import EsntialBuyNowCTA from './EsntialBuyNowCTA';

export default EsntialBuyNowCTA;
